import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {Component, Input, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {Observable} from 'rxjs';
import { UntypedFormControl, UntypedFormGroup, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {map, startWith, debounceTime, switchMap} from 'rxjs/operators';
import {LookupService, TypesService, ProductService} from '../../../services';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import {ClientService, PARTY_ROLE_TYPES_IDS} from '../../../services';
import {OAuthService} from 'angular-oauth2-oidc';
import _ from 'lodash';
import {CHANNEL, LCA_ORIGINATOR_PARTY_ROLE_ID, RETAIL} from '../../../_global/wiz.constants';
import {DataHandlerService} from '../../../services/data-handler.service';
import { MatSelectModule } from '@angular/material/select';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-originator-broker',
    templateUrl: 'originator-broker.component.html',
    standalone: true,
    imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, NgIf, MatProgressSpinnerModule, MatProgressSpinnerModule, MatFormFieldModule, MatFormFieldModule, MatInputModule, MatInputModule, MatAutocompleteModule, MatAutocompleteModule, NgFor, MatOptionModule, MatOptionModule, ValidationPartialComponent, MatSelectModule, MatSelectModule, AsyncPipe]
})
export class OriginatorBrokerComponent extends WizardWidgetComponent implements OnInit {
  @ViewChild(MatAutocomplete, {static: true}) matAutocomplete: MatAutocomplete;
  @Input() public formGroup: UntypedFormGroup;
  @Input() public productCategory: String; // default to car loan for now
  @Input() public isHomeLoan: boolean;
  @Input() public isFurtherAdvance = false;
  @Output() public brokerDetails = new EventEmitter<any>();
  @Output() public originatorDetails = new EventEmitter<any>();

  // originatorDataset: any;
  originators = [];
  brokers = [];
  contacts = [];
  filteredBrokers: Observable<any>;
  filteredOriginators: Observable<any>;
  brokerDisplayCtrl: UntypedFormControl;
  selectedContact: any = '';
  public loaded = false;

  public broker: UntypedFormControl;
  public originator: UntypedFormControl;
  public contact: UntypedFormControl;

  public originatorConfig;
  public INTERNAL_SITE_TYPE = '4';
  public SITE_TYPE_CLAIM_ID = 'http://schemas.firstmac.com.au/ws/2009/12/identity/claims/sitetypeid';
  public isInternalUser = false;


  constructor(public dataHandlerService: DataHandlerService,
              private lookupService: LookupService,
              private clientService: ClientService,
              private typesService: TypesService,
              private oAuthService: OAuthService,
              private productService: ProductService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.typesService.getTypesList('product-category-originator-filters-by-login-category').then((types: any) => {
      this.isInternalUser = String(this.oAuthService.getIdentityClaims()[this.SITE_TYPE_CLAIM_ID]) === String(this.INTERNAL_SITE_TYPE);
      this.originatorConfig = types.find(t => t.id === this.productCategory);

      if (this.originatorConfig) {
        const selectedConfig = (this.isInternalUser && this.originatorConfig.ext) ? this.originatorConfig.ext.internal : this.originatorConfig.ext.external;
        if (selectedConfig && selectedConfig.brokerPartyRoleTypeIds) {
          this.opts = this.opts || {};
          this.opts.brokerPartyRoleTypeIds = selectedConfig.brokerPartyRoleTypeIds.join(',');
        }
        this.getOriginators(selectedConfig.originatorPartyRoleIds);
      }
    });
    this.broker = this.formGroup.get('broker') as UntypedFormControl;
    this.originator = this.formGroup.get('originator') as UntypedFormControl;
    this.contact = this.formGroup.get('contact') as UntypedFormControl;
    this.brokerDisplayCtrl = new UntypedFormControl('');
    this.formGroup.disable();

    if (this.originator && this.originator.value) {
      this.originatorDetails.emit(this.originator.value);
      this.setOriginatorChannel(this.originator.value);
    }
    if (this.broker && this.broker.value) {
      this.brokerDetails.emit(this.broker.value);
    }

    if (!this.isFurtherAdvance) {
      this.filteredOriginators = this.formGroup.get('originator').valueChanges.pipe(
        debounceTime(500))
        .pipe(
          startWith(''),
          map(val => {
            this.loaded = false;
            return val;
          }),
          switchMap((val: any) => {
            if (!val) {
              val = '';
            }
            // make sure that `val` variable is a string to avoid fetching when the `val` variable is an object.
            if (typeof val === 'string') {
              return this.lookupService.getOriginators(val);
            }
            return Promise.resolve([]);
          }),
          map(res => res.map((b) => {
            return {id: b.PartyRoleID, name: b.PartyName};
          })),
          map(val => {
            this.loaded = true;
            this.originators = val;
            return val;
          }),
        );
    } else {
      this.formGroup.get('originator').disable();
    }

    this.filteredBrokers = this.formGroup.get('broker').valueChanges.pipe(
      debounceTime(500))
      .pipe(
        startWith(''),
        map(val => {
          this.loaded = false;
          return val;
        }),
        switchMap((val: any) => {
          if (this.originator.value && this.originator.value.id && this.opts) {
            // make sure `this.opts.brokerPartyRoleTypeIds` is not undefined to avoid invalid request error.
            if (this.originator.value.id && this.opts.brokerPartyRoleTypeIds) {
              return this.lookupService.getBrokersByOriginator((val && val.name) ? val.name : (val || ''), this.originator.value.id, this.opts.brokerPartyRoleTypeIds);
            }
          }
          return Promise.resolve([]);
        }),
        map(res => res.map((b) => {
          return {id: b.PartyRoleID, name: b.PartyName};
        })),
        map(val => {
          this.loaded = true;
          this.brokers = val;
          return val;
        }),
      );

    this.formGroup.get('broker').valueChanges.pipe(debounceTime(500)).subscribe(async (val) => {
      // this logic retrieves the internal BDM for a particular broker
      if (val && val.id) {
        // emit broker details
        this.brokerDetails.emit(this.broker.value);
        this.productService.setProductParameters({
          oid: val.id
        });

        this.clientService.getBrokerAdditional(this.broker.value.id)
          .subscribe((brokerAdditionalResult: any) => {
            if (brokerAdditionalResult && brokerAdditionalResult.isRetail) {
              this.dataHandlerService.sendIsRetailFlag(true);
            } else {
              this.dataHandlerService.sendIsRetailFlag(false);
            }

            if (brokerAdditionalResult && brokerAdditionalResult.bidCompliance) {
              this.dataHandlerService.sendBidCompliantFlag(true);
            } else {
              this.dataHandlerService.sendBidCompliantFlag(false);
            }

            if (brokerAdditionalResult && brokerAdditionalResult.allowDialDown) {
              this.dataHandlerService.sendDialDownDisabledFlag(false);
            } else {
              this.dataHandlerService.sendDialDownDisabledFlag(true);
            }
          });
        const bdmPartyRoleId = await this.getInternalBDMPartyRoleId(val.id);

        this.formGroup.get('salesPerson').patchValue(bdmPartyRoleId ? {
          id: bdmPartyRoleId
        } : null);
      }
    });
  }

  setOriginatorChannel(originator: any) {
    console.log('setOriginatorChannel', originator);

    if (originator && originator.id) {
      if (originator.id === LCA_ORIGINATOR_PARTY_ROLE_ID) {
        this.dataHandlerService.setOriginatorChannel(CHANNEL.LCA);
      } else {
        this.dataHandlerService.setOriginatorChannel(CHANNEL.FMC);
      }
    }
  }

  chooseFirstOption(): void {
    this.matAutocomplete.options.first.select();
  }

  public clearBrokers() {
    this.brokerDisplayCtrl.reset();
    this.broker.patchValue(null);
  }

  public clearContact() {
    this.contact.patchValue(null);
  }

  public defaultValue(formControl: AbstractControl, options) {
    if (formControl.value && formControl.value.id && options && options.length > 1) {
      formControl.patchValue(options.find(o => o.id === formControl.value.id));
    } else if (options && options.length === 1) {
      formControl.patchValue(options[0]);
    } else {
      formControl.patchValue(null);
    }
  }

  getOriginators(originatorPartyRoleIds = []): void {
    let fetch = this.lookupService.getOriginators(_.get(this.formGroup.value, 'originator.name', '')).toPromise()
      .then((oList: any) => {
        return oList.map(o => {
          return {id: o.PartyRoleID, name: o.PartyName};
        });
      }); // format this to the same as the original one
    if (originatorPartyRoleIds && originatorPartyRoleIds.length > 0) {
      fetch = Promise.all(originatorPartyRoleIds.map(originator =>
        this.clientService.retrievePartyInfoFromPartyRole(originator).then((o: any) => {
          return {id: o.partyRole.iD, name: o.party.party.name};
        })
      ));
    }
    fetch
      .then(originators => {
        this.loaded = true;

        if (!this.isFurtherAdvance) {
          this.formGroup.enable();
        } else {
          this.formGroup.get('originator').disable();
          this.formGroup.get('broker').enable();
          this.formGroup.get('contact').enable();
        }

        this.originators = originators;

        // init on change behaviors
        this.originator.valueChanges.subscribe((val) => {
          if (val && val.id) {
            this.originatorDetails.emit(val);
            this.setOriginatorChannel(val);
            const brokerName = (this.broker.value && this.broker.value.name) ? this.broker.value.name : '';
            this.lookupService.getBrokersByOriginator(brokerName, val.id, this.opts.brokerPartyRoleTypeIds).subscribe((res) => {
              this.brokers = res.map((b) => {
                return {id: b.PartyRoleID, name: b.PartyName};
              });
              if (this.broker.value && this.broker.value.id && !this.brokers.find(b => b.id === this.broker.value.id)) {
                this.broker.reset(); // only reset if the broker does not exist
                this.brokerDisplayCtrl.reset();
              }
              this.defaultValue(this.broker, this.brokers);
            });
          }
        });

        this.broker.valueChanges.subscribe((val) => {
          // console.log('broker changed');
          if (val && val.id) {
            this.lookupService.getContactsByBroker(val.id).subscribe((c) => {
              this.contacts = c.map((b) => {
                return {id: b.partyRole.iD, name: b.partyName};
              });
              if (this.contact.value && this.contact.value.id && !this.contacts.find(b => b.id === this.contact.value.id)) {
                this.contact.reset();
              }
              this.defaultValue(this.contact, this.contacts);
            });
          } else {
            this.contact.reset();
            this.contacts = [];
          }
        });

        // default the originator
        this.defaultValue(this.originator, this.originators);
        // this.defaultValue(this.contact, this.contacts);
      }, (err) => {
        console.log('Error retrieving originator information');
        this.loaded = true;
      });
  }

  displayName(object) {
    return (object) ? object.name : null;
  }

  /**
   * get the partyRole on the partyRoleList by partyRoleTypeId
   * @param prList {Object[]} party role list
   * @param partyRoleTypeId {number}
   * @returns {Object|null} partyrole or null
   */
  public getPartyRoleByPartyRoleTypeId (prList, partyRoleTypeId: number) {
    return prList.find((partyRoles: any) => partyRoles.PartyRoleType.iD === partyRoleTypeId);
  }

  /**
   * get internal bdm party role id by broker party role id
   * @param brokerPartyRoleId
   * @returns
   */
  public getInternalBDMPartyRoleId (brokerPartyRoleId: string): Promise<string|null> {
    return new Promise((resolve) => {
      this.clientService.retrieveParentsWithRelationshipTypeId(brokerPartyRoleId, PARTY_ROLE_TYPES_IDS.INTERNAL_BDM_RELATIONSHIP_TYPE).subscribe((res) => {
        if (!res || res.length === 0) {
          console.log('SETTING SALES-PERSON ERROR: No Owners found');
          resolve(null);
          return;
        }
        const {
          party: parentParty
        } = res[0] || {};
        if (!parentParty) {
          console.log('SETTING SALES-PERSON ERROR: No Owners found');
          resolve(null);
          return;
        }
        this.clientService.retrievePartyRoles(parentParty.iD).subscribe(pprList => {
          const parentPartyRole = this.getPartyRoleByPartyRoleTypeId(pprList, PARTY_ROLE_TYPES_IDS.INTERNAL_BDM);
          const bdmPartyRoleId = parentPartyRole?.iD || null;
          if (!parentPartyRole) {
            console.log('SETTING SALES-PERSON ERROR: No Owners found');
          }
          resolve(bdmPartyRoleId);
        });
      });
    });
  }
}
